import { PAD_V2_CONTAINER } from '../../components/prescriptionPad/rightPanel/workspace/PadContainer';

const onContainerClick = (): void => {
    // focus cards
    const elCon = document.getElementById(PAD_V2_CONTAINER);

    if (!elCon) {
        return;
    }

    const els = elCon.querySelectorAll('.focusable');

    let isAnyFocussed = false;

    for (let index = 0; index < els.length; index++) {
        const element = els[index];
        if (
            [
                ...element.querySelectorAll('input:focus'),
                ...element.querySelectorAll('textarea:focus'),
            ].length > 0
        ) {
            isAnyFocussed = true;
            element.classList.add('infocus');
        } else {
            element.classList.remove('infocus');
        }
    }

    if (isAnyFocussed) {
        elCon.classList.add('focused');
    } else {
        elCon.classList.remove('focused');
    }
};

export default onContainerClick;
